import { Trans, useTranslation } from "react-i18next";
import Toggle from "../ui/Toggle";
import * as S from "./plans.style";
import FlexContainer from "../ui/FlexContainer";
import { SVG } from "../ui/SVG";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import PromotionArrow from "~/assets/svg/promotion-arrow.svg";

type Props = {
  isAnnual: boolean;
  toggleControl: () => void;
  biggestMonthsOff?: number;
  context?: "settings" | "modal";
};

export const TogglePlan = ({
  isAnnual,
  toggleControl,
  biggestMonthsOff,
  context,
}: Props) => {
  const { t } = useTranslation();
  return (
    <FlexContainer
      flexDirection="column"
      alignItems="center"
      gap={0}
      data-testid="plan-cycle">
      <FlexContainer
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        style={{ marginTop: isAnnual ? "1.6rem" : 0 }}>
        <S.ToggleContentText className={`${!isAnnual ? "selected" : ""}`}>
          {t("settings.monthly")}
        </S.ToggleContentText>
        <Toggle onChange={toggleControl} value={isAnnual} />
        <S.ToggleContentText className={`${isAnnual ? "selected" : ""}`}>
          {t("settings.annual")}
        </S.ToggleContentText>
        <S.PromotionText>
          <img src={PromotionArrow} alt="" />
          <Trans
            i18nKey="settings.up_to_months_off_plans"
            values={{ days: biggestMonthsOff }}
          />
        </S.PromotionText>
      </FlexContainer>

      {/* {isAnnual && context === "settings" && (
        <S.AnnualDisclaimerBanner>
          <SVG icon={faCircleInfo} />
          {t("settings.annual_downgrade_note")}
        </S.AnnualDisclaimerBanner>
      )} */}
    </FlexContainer>
  );
};
